import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const BidsIcon = ({ className, fill = "#2A2A2A" }: Props) => {
  return (
    <svg
      className={cn("h-[15px] w-[14px] shrink-0", className)}
      viewBox="0 0 14 15"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.84961 0.00879657C2.16672 0.0670777 2.38043 0.384773 2.3252 0.717781L1.24316 7.24122C1.23741 7.2771 1.23567 7.31472 1.23047 7.35059H3.49902C4.14239 7.35059 4.66593 7.8997 4.66602 8.5752C4.66603 9.25076 5.1896 9.80079 5.83301 9.80079H8.16602C8.76915 9.80061 9.26742 9.31725 9.32715 8.7002L9.33887 8.4502C9.39871 7.83333 9.89602 7.3508 10.499 7.35059H12.7686C12.7633 7.31456 12.7607 7.27726 12.7549 7.24122L11.6748 0.717781C11.6197 0.384781 11.8332 0.0679286 12.1504 0.00977314C12.4686 -0.0467474 12.7698 0.175841 12.8252 0.508797L13.9053 7.03126C13.9529 7.31711 13.9997 8.11887 14 8.18458V11.6377C13.9999 13.326 12.6919 14.6998 11.084 14.7002H2.91602C1.30815 14.6998 0.000138948 13.326 0 11.6377V8.18458C0.000295442 8.11887 0.0470504 7.31674 0.0947266 7.03028L1.1748 0.50782C1.2302 0.175382 1.5301 -0.0478983 1.84961 0.00879657ZM1.16602 11.6377C1.16615 12.6504 1.95157 13.4752 2.91602 13.4756H11.084C12.0484 13.4752 12.8338 12.6504 12.834 11.6377V8.5752H10.5C10.5 9.92634 9.45284 11.0254 8.16602 11.0254H5.83398C4.54716 11.0254 3.50002 9.92634 3.5 8.5752H1.16602V11.6377Z"
      fill={fill}
    />
    <path
      d="M10.6631 4.9004C10.9441 4.90063 11.186 5.11158 11.2373 5.40235C11.3029 5.7781 11.0273 6.12569 10.6631 6.12598H3.33887C2.97439 6.12587 2.69917 5.77797 2.76562 5.40137L2.79297 5.29688C2.87722 5.06215 3.09204 4.90063 3.33789 4.9004H10.6631Z"
      fill={fill}
    />
    <path
      d="M10.2334 2.45118C10.5144 2.45135 10.7562 2.66144 10.8076 2.95216C10.8733 3.32798 10.5977 3.6746 10.2334 3.67481H3.77051C3.40624 3.67471 3.13029 3.3285 3.19629 2.95216C3.24759 2.66203 3.4886 2.45146 3.76953 2.45118H10.2334Z"
      fill={fill}
    />
    <path
      d="M9.80371 7.51141e-06C10.0848 5.26431e-05 10.3265 0.21115 10.3779 0.501961C10.4438 0.877998 10.1682 1.22554 9.80371 1.22559H4.20215C3.83766 1.22548 3.56242 0.877601 3.62891 0.500984C3.68038 0.211109 3.92041 0.000295973 4.20117 7.51141e-06H9.80371Z"
      fill={fill}
    />
    </svg>
  );
};

export default BidsIcon;
